
 
 
  
import { verify   } from 'jsonwebtoken'; 
 
 
import { store } from '../app/store';
  
export const checkToken = (token: string)  => { 
  if (!token) return undefined; 
   
  const text =  store.getState().token.keyCert;
  //console.log('text', text);
  const result =  verify(token, text, function(err: any, decoded: any) {
    if (err){
      console.log(err); 
      return err;
    } 
    
    return decoded ; 
  }); 
  return result ;  
     
};


export const isTokenExpiredToken = (decodedToken: any): boolean => { 
  return !decodedToken || decodedToken?.name ===  'TokenExpiredError'; 
};
